/**
 * Maps the custom typography variants onto sensible elements.
 *
 * MUI renders a variant it does not recognise as a <span>, so `numeric` and
 * `sectionLabel` need declaring here to come out as real markup rather than
 * inline spans. The styles themselves live with the rest of the type scale in
 * getDesignTokens.
 *
 * `sectionLabel` maps to <h6>: it IS the heading for the block beneath it, and
 * a screen reader should be able to navigate by it even though it is set small
 * and quiet visually.
 */
export const typographyCustomizations = {
  MuiTypography: {
    defaultProps: {
      variantMapping: {
        numeric: 'span',
        sectionLabel: 'h6',
      },
    },
  },
};

export default typographyCustomizations;
